import React from 'react';
import ReactDOM from 'react-dom';

import img from '../images/MilkyChance_Blossom_FrontCover.png';
import Iconset from './icons';

import '../styles/preorder-box.scss';


class PreorderBox extends React.Component{

	render(){
		return (<div className="preorder-box">
			<img src={img} alt="Milky Chance — Blossom - FrontCover"/>
			<div className="preorder-box-text">
				<h2>Order Blossom</h2>
				<div className="share-bar-row">
					<a className="share-bar-ico" target="_blank" href="http://smarturl.it/Blossom_AM">
						<Iconset.appleHolo />
					</a>
					<a className="share-bar-ico" target="_blank" href="http://w.universal-music.de/save/campaign?campaign_id=7">
						<Iconset.spotifyHolo />
					</a>
					<a className="share-bar-ico" target="_blank" href="http://smarturl.it/Blossom_IT">
						<Iconset.itunesHolo />
					</a>
					<a className="share-bar-ico" target="_blank" href="http://smarturl.it/Blossom_AMZ">
						<Iconset.amazonHolo />
					</a>
				</div>
			</div>
		</div>);
	}
}

export default PreorderBox;


// WEBPACK FOOTER //
// ./src/scripts/preorder-box.js